export default __webpack_public_path__ + "static/media/EM0390.34I-22653_-15115_0.0c9578c5.jpg";